import { Box } from '@mui/material';
import { VyTableToolbar } from '../../../../components/new-design/table/vy-table-toolbar/vy-table-toolbar';
import {
  reportSearchContainerSx,
  reportSearchInputSx,
} from '../../reports-components/report-toolbar-styles';

interface ReportSearchFieldProps {
  defaultValue: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const ReportSearchField: React.FC<ReportSearchFieldProps> = ({ defaultValue, onChange }) => (
  <Box
    sx={[{
      display: "flex",
      flexDirection: "column"
    }, ...(Array.isArray(reportSearchContainerSx) ? reportSearchContainerSx : [reportSearchContainerSx])]}>
    <VyTableToolbar.SearchInput
      onChange={onChange}
      defaultValue={defaultValue}
      placeholder="Search"
      showLabel={false}
      sx={reportSearchInputSx}
    />
  </Box>
);
